import { render, staticRenderFns } from "./PrincipalPage.vue?vue&type=template&id=1fa02432&scoped=true"
import script from "./PrincipalPage.js?vue&type=script&lang=js&external"
export * from "./PrincipalPage.js?vue&type=script&lang=js&external"
import style0 from "./PrincipalPage.vue?vue&type=style&index=0&id=1fa02432&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa02432",
  null
  
)

export default component.exports